import { useScaffold } from "@Light/scaffold";
import type { InvoiceResponse } from "@Light/services/lightTypes";
import { clsx } from "clsx";
import { usePaymentDays } from "./common";

// Keep in sync with: developer-client/src/components/accounts/InvoiceStatus.tsx

export type InvoiceStatusProps = React.ComponentProps<"span"> & {
  invoice: InvoiceResponse;
};

export const InvoiceStatus: React.FC<InvoiceStatusProps> = ({
  className,
  invoice,
}) => {
  const paymentDays = usePaymentDays(invoice);
  const scaffold = useScaffold();
  if (invoice.paid_at) {
    return (
      <span className={clsx(scaffold.page.colors.text.success, className)}>
        Paid
      </span>
    );
  }
  if (invoice.is_deferred && invoice.total_cents < 50) {
    return (
      <span className={clsx("text-gray-500", className)}>
        Deferred by {scaffold.page.companyName}
      </span>
    );
  }
  if (invoice.is_deferred) {
    return (
      <span className={clsx("text-gray-500", className)}>Deferred by you</span>
    );
  }
  if (invoice.rebill_invoice) {
    return (
      <span className={clsx("text-gray-500", className)}>
        Cancelled for correction
      </span>
    );
  }
  if (paymentDays < 0) {
    return (
      <span className={clsx(scaffold.page.colors.text.error, className)}>
        Past due
      </span>
    );
  }
  if (paymentDays === 0) {
    return (
      <span className={clsx(scaffold.page.colors.text.warn, className)}>
        Autopay today
      </span>
    );
  }
  return (
    <span className={clsx(scaffold.page.colors.text.warn, className)}>
      Autopay in {paymentDays} {paymentDays === 1 ? "day" : "days"}
    </span>
  );
};
